let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("7jH9e")]).then(() => parcelRequire('7vcce'));